module.exports = __webpack_public_path__ + "img/slot-bgaming.5d53fab0.png";